export const DRIP_DELAY = 'DRIP_DELAY';
export const STATIC_ANCHOR = 'STATIC_ANCHOR';
export const PROPERTY_ANCHOR = 'PROPERTY_ANCHOR';